import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DialogActionsComponent } from './dialog-actions.component';
import { DialogCloseDirective } from './dialog-close.directive';
import { DialogContentComponent } from './dialog-content.component';
import { DialogHeaderComponent } from './dialog-header.component';
import { DialogContainerComponent } from './dialog-container.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    DialogHeaderComponent,
    DialogContentComponent,
    DialogActionsComponent,
    DialogCloseDirective,
    DialogContainerComponent,
  ],
  exports: [
    DialogHeaderComponent,
    DialogContentComponent,
    DialogActionsComponent,
    DialogCloseDirective,
    DialogContainerComponent,
  ],
})
export class DialogModule {}
